import { Error } from '../ErrorHandling';
import { Resource } from '../Resource/Types';
import { Report } from '../ReportsStore/Types';

interface Waiting {
  kind: 'waiting';
}

interface Loading {
  kind: 'loading';
}

interface Ready {
  kind: 'ready';
  reportResource: ReportResource;
  currentDashboardId: number;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (reportResource: ReportResource): Ready => ({
  kind: 'ready',
  currentDashboardId: reportResource.payload.dashboards[0].payload.id,
  reportResource,
});

export const updateCurrentDashboardId = (currentDashboardId: number, state: Ready): Ready => ({
  ...state,
  currentDashboardId,
});

export type State = Waiting | Loading | Ready | Error;

export type DashboardType = 'quicksight';

export interface Dashboard {
  id: number;
  name: string;
  dashboardType: DashboardType;
  dashboardUri: string;
  height: number;
  width: number;
}

export type DashboardResource = Resource<Dashboard>;

export interface ReportWithDashboards extends Omit<Report, 'description'> {
  dashboards: DashboardResource[];
}
export type ReportResource = Resource<ReportWithDashboards>;
